module Eseebase {

    export class TabModel {
        url: string;
        name: string;
        text: string;
        isEnabled: boolean;
        isShown: boolean;
        cssClass: string;
    }
}